import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Navigation.module.css";
const NavDrawer = (props) => {
  const { navTogglerClass, navTogglerHandler, pathname } = props;
  return (
    <nav className={navTogglerClass}>
      <button
        type="button"
        className="btn ml-auto  d-block d-lg-none shadow-none"
        onClick={navTogglerHandler}
      >
        <span className={styles.bar_icon}>
          <i className="fa fa-times text-danger "></i>
        </span>
      </button>
      <ul
        className={`nav mx-auto d-block d-lg-flex text-center text-lg-start 
          ${styles.nav_menu}`}
      >
        <li className="nav-item  mb-4 my-lg-2 ">
          <NavLink
            to="/"
            className={` nav-link ${pathname === "/" && styles.navlink_active}`}
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item my-4 my-lg-2">
          <NavLink
            to="/menu"
            className={` nav-link ${
              pathname === "/menu" && styles.navlink_active
            }`}
          >
            Menu
          </NavLink>
        </li>
        <li className="nav-item my-4 my-lg-2">
          <NavLink
            to="/blog"
            className={` nav-link ${
              pathname === "/blog" && styles.navlink_active
            }`}
          >
            Blog
          </NavLink>
        </li>
        <li className="nav-item my-4 my-lg-2">
          <NavLink
            to="/about"
            className={` nav-link ${
              pathname === "/about" && styles.navlink_active
            }`}
          >
            About us
          </NavLink>
        </li>
      </ul>
      <button className={styles.contact_btn + " btn  d-none d-lg-block "}>
        <a href="tel:+351 933 073 523">+351 933 073 523</a>
      </button>
    </nav>
  );
};

export default NavDrawer;
